<div class="row mb-3">
	<div class="col-auto">
        <span jhiTranslate="program.my.studies.tab.description">Click on studies to display information</span>
	</div>
	<div class="col-1">
		<span class="throbber" [style.visibility]="isLoading ? 'visible' : 'hidden'"></span>
	</div>
</div>
<div *ngIf="studies">
	<div class="row" *ngIf="studies.length else nodata">
		<div class="col-md-6">
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
						<th jhiSortBy="name"><span jhiTranslate="program.my.studies.col.name"></span><span class="fa fa-sort"></span></th>
						<th jhiSortBy="studyType.label"><span jhiTranslate="program.my.studies.col.type"></span><span class="fa fa-sort"></span></th>
						<th jhiSortBy="startDate"><span jhiTranslate="program.my.studies.col.date"></span><span class="fa fa-sort"></span></th>
						<th jhiSortBy="parent.name"><span jhiTranslate="program.my.studies.col.folder"></span><span class="fa fa-sort"></span></th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let study of studies" [class.selected]="study.selected"
						(click)="onStudyClick(study)">
						<td>
							<span *jhiHasNotAnyAuthority="STUDIES_EDITION_PERMISSIONS" class="text-wrap">{{study.name}}</span>
                            <button *jhiHasAnyAuthority="STUDIES_EDITION_PERMISSIONS" type="button" class="btn btn-link text-wrap" (click)="urlService.openStudy(study.studyId, study.name, context.program); $event.stopPropagation();"><truncate-span [textInput]="study.name" [maxLength]="255" [showCopyButton]="true"></truncate-span></button>
						</td>
						<td>{{study.type}}</td>
						<td>{{study.date}}</td>
						<td>{{study.folder}}</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="row">
				<div class="col">
					<div class="pagination-container">
						<div class="pagination-box pagination-box-left"></div>
						<div class="pagination-box">
							<ngb-pagination [collectionSize]="totalCount" [(page)]="page" [pageSize]="pageSize" [disabled]="isLoading"
											[maxSize]="5" [rotate]="true" (pageChange)="load()"></ngb-pagination>
						</div>
						<div class="pagination-box pagination-box-right"></div>
					</div>
				</div>
			</div>
		</div>
		<!-- Workaround for right overlap (md-5) and min-height -->
		<div class="col-md-5">
			<div class="row">
				<div class="col">
					<h5 jhiTranslate="program.my.studies.plot.title"></h5>
				</div>
			</div>
			<div class="row" *ngIf="study?.metadata?.observations?.length else noobservations">
				<div class="col" style="min-height: 400px" >
					<ngx-charts-bar-vertical-stacked
						[view]="view"
						[results]="study.metadata.observations"
						[scheme]="colorScheme"
						[gradient]="gradient"
						[xAxis]="showXAxis"
						[yAxis]="showYAxis"
						[legend]="showLegend"
                        [legendTitle]="legendLabel | translate"
						[showXAxisLabel]="showXAxisLabel"
						[showYAxisLabel]="showYAxisLabel"
						[xAxisLabel]="xAxisLabel | translate"
						[yAxisLabel]="yAxisLabel | translate"
						[animations]="animations">
					</ngx-charts-bar-vertical-stacked>
				</div>
			</div>
			<ng-template #noobservations>
				<div class="row">
					<div class="col">
						<span jhiTranslate="program.my.studies.no.observations"></span>
					</div>
				</div>
			</ng-template>
			<div class="row mt-3">
				<div class="col">
					<div class="alert alert-warning" *ngIf="study?.metadata?.hasMoreEnvironments">
						<i class="fa fa-warning"></i>&nbsp;
						<span jhiTranslate="program.my.studies.max.env.warning" [translateValues]="{param: MAX_ENVIRONMENTS_TO_SHOW}"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ng-template #nodata>
		<div class="row">
			<div class="col-md-6">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr>
						<th></th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td jhiTranslate="no.data"></td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</ng-template>
</div>
